import { RootState } from 'models/store';

// ==============================|| PRODUCTION PLANNING SELECTORS ||============================== //

export const selectDispatcherProductionPlanListForOnlineDispatching = (
  state: RootState
) => state.dispatcher.deviceProductionPlanListForOnlineDispatching;

export const selectDispatcherProductionPlanListForPlanning = (
  state: RootState
) => state.dispatcher.deviceProductionPlanListForPlanning;

export const selectDispatcherBusinessDay = (state: RootState) =>
  state.dispatcher.selectedBusinessDay;

export const selectDailyDiagram = (state: RootState) =>
  state.dispatcher.dailyDiagram;

export const selectDailyDiagramList = (state: RootState) =>
  state.dispatcher.dailyDiagramList;

export const selectProductionPlanActivityLog = (state: RootState) =>
  state.dispatcher.productionPlanActivityLog;

export const selectDailyDiagramActivityLog = (state: RootState) =>
  state.dispatcher.dailyDiagramActivityLog;

export const selectIsDailyDiagramReady = (state: RootState) =>
  state.dispatcher.isReady.isDailyDiagramReady;

export const selectIsDeviceMetricListReady = (state: RootState) =>
  state.dispatcher.isReady.isDeviceMetricListReady;

export const selectIsMetricListForBalanceGroupChartReady = (state: RootState) =>
  state.dispatcher.isReady.isMetricListForBalanceGroupChartReady;

export const selectIsMetricListForSystemValuesChartReady = (state: RootState) =>
  state.dispatcher.isReady.isMetricListForSystemValuesChartReady;

export const selectIsProductionPlanListReady = (state: RootState) =>
  state.dispatcher.isReady.isProductionPlanListReady;
